import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ShoppingCartOutlinedSvg from "@ant-design/icons-svg/es/asn/ShoppingCartOutlined";
import AntdIcon from "../components/AntdIcon";
var ShoppingCartOutlined = function ShoppingCartOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ShoppingCartOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ShoppingCartOutlined.displayName = 'ShoppingCartOutlined';
}
export default /*#__PURE__*/React.forwardRef(ShoppingCartOutlined);